export const URLAPISUBIDA = 'https://petsupplies.com.ar/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://petsupplies.com.ar/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://petsupplies.com.ar/notis/'

export const URLAPISUBIDAPDF = 'https://petsupplies.com.ar/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://petsupplies.com.ar/notis/'